import React, { useLayoutEffect } from "react";
import CommonPagesWrapper from "./style";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  // Constructing the base URL dynamically based on the current domain
  const protocol = window.location.protocol;
  const host = window.location.host;
  const baseUrl = `${protocol}//${host}`;

  const navigate = useNavigate();

  useLayoutEffect(() => {
    const hasReloaded = sessionStorage.getItem('hasReloaded');

    if (!hasReloaded) {
      // Set flag to prevent multiple redirects
      sessionStorage.setItem('hasReloaded', 'true');

      // Use window.location.replace to redirect without adding to history
      window.location.replace(baseUrl);
    } else {
      sessionStorage.removeItem('hasReloaded');
    }
  }, [navigate, baseUrl]);

  return <CommonPagesWrapper>404 Not Found</CommonPagesWrapper>;
};

export default PageNotFound;
